import Vue from 'vue';
import Router from 'vue-router';
import { PageNotFound } from './shared/components';
import store from "./app-state";
import clientRoutes from "@/app/client/client-routes";

const baseRoutes = [
  {
    path: '/',
    redirect: '/main',
  },
  {
    path: '/404',
    name: 'Page404',
    component: PageNotFound,
    meta: {
      title: 'Страница не найдена',
      wfPage: '6667fca8692ff013d2a6a92b',
      wfSite: '652921c910bae02d8870dddf'
    },
  },
];

Vue.use(Router);
const router = new Router({
  mode: 'hash',
  routes: [
    ...baseRoutes,
    ...clientRoutes,
    {
      path: '*',
      redirect: '/404',
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 }; // прокрутка в начало страницы
    }
  },
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Всем займы';
  if (to.meta.wfPage) {
    document.documentElement.setAttribute('data-wf-page', to.meta.wfPage);
  }

  // Сохраняем query параметры при всех переходах, кроме перехода на ту же страницу с теми же параметрами
  if (Object.keys(from.query).length > 0) {
    // Объединяем существующие параметры from с to (приоритет у новых параметров)
    const mergedQuery = { ...from.query, ...to.query };

    // Если текущие параметры не совпадают с объединенными, делаем редирект
    if (JSON.stringify(to.query) !== JSON.stringify(mergedQuery)) {
      next({
        path: to.path,
        query: mergedQuery,
        hash: to.hash
      });
      return;
    }
  }

  next();
});

export default router;
